// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkBoxButton_checkbox__2FpNt","label":"checkBoxButton_label__1xm8K"};